
// Utility function to categorize goal types based on target date
const goalCategoryFromTargetDate = (targetDateTime: string) => {
  const currentDate = new Date()
  const target = new Date(targetDateTime)
  const diffInYears = (target.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
  
  if (diffInYears > 5) return 'Long term'
  if (diffInYears > 3 && diffInYears <= 5) return 'Mid term'
  return 'Short term' // diffInYears <= 3
}

export const FinancialGoalsUtils = { goalCategoryFromTargetDate };